<template>
  <div class="fragment-page-container">
    <img class="bg-img" src="../../../assets/images/activity/fragment/2021bg.png">
    <img class="back-home" @click="backHome" src="../../../assets/images/activity/fragment/back-home-fragment.png" />

    <div class="activity-picture">
      <div class="pic-item" v-for="(item,index) in monthList" :class="getMonthStyle(index)" :key="index">
        <div v-if="month === item" @click="showMonthPiece">
          <img class="active-bg bgAnimation" src="../../../assets/images/activity/fragment/2021active-bg.png">
          <img class="month-img month-img-active" :src="getMonthImg(item,true)">
        </div>
        <div v-else>
          <img class="month-img" :src="getMonthImg(item,false)">
        </div>
      </div>
    </div>

    <div class="point">
      <div>在本次活动中你已经扫码{{scanCount}}次，累积获取积分{{getPoint}}分</div>
    </div>

    <div class="activity-schedule">
      <div class="activity-title">
        扫码集图鉴
        <img @click="activityInfoPopup" class="activity-rules" src="../../../assets/images/activity/fragment/2021activity-rules.png">
      </div>
      <div  class="schedule">
        当月拼图进度：{{pieceCount}}/6&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;活动剩余{{toEndDate}}天
      </div>
    </div>

    <div class="bottom-nav">
      <div class="bottom-nav-btn" @click="gotoWeb('activity-all-picture')">
        <img class="bottom-nav-icon" src="../../../assets/images/activity/fragment/2021all-picture.png">
      </div>
      <div class="bottom-nav-scan-btn" >
        <img class="bottom-nav-icon-scan" @click="scanCode" src="../../../assets/images/activity/fragment/2021scan.png">
      </div>
      <div class="bottom-nav-btn" @click="gotoWeb('activity-fragment-info')">
        <img class="bottom-nav-icon" src="../../../assets/images/activity/fragment/2021my.png">
      </div>
    </div>

    <van-popup v-model="show" :lock-scroll='false' class="activity-detail"  :close-on-click-overlay='false'>
      <div class="block"></div>
      <img @click="closePopup()" class="close-img" src="../../../assets/images/activity/fragment/2021activity-detail-close.png">
      <img class="detail-img"  src="../../../assets/images/activity/fragment/2021activity-detail.png">
       <div class="bottom-text">本活动最终解释权归博世易加网所有</div>
    </van-popup>

      <van-popup  v-model="monthPiecePopup">
        <div class='month-piece'>
          <div>
            <img class="piece-one" :src="getImgSrc(0)">
            <img class="piece-two" :src="getImgSrc(1)">
            <img class="piece-three" :src="getImgSrc(2)">
          </div>
          <div>
            <img class="piece-four" :src="getImgSrc(3)">
            <img class="piece-five" :src="getImgSrc(4)">
            <img class="piece-six" :src="getImgSrc(5)">
          </div>
        </div>
      </van-popup>

      <van-dialog v-model="newPieceDialog" @confirm="collectAllPiece" title="扫码成功">
        <div class="newPieceDialog">
          <div class="newPieceInfo">恭喜你获得一个碎片,获得50易加积分</div>
          <img :src="getNewPieceImgSrc(piece.pieceCode)" />
          <div style="margin-bottom:10px;font-size:12px">{{getPieceName(piece.pieceCode)}}</div>
        </div>
      </van-dialog>

      <van-dialog v-model="pointDialog" >
        <div class="newPieceDialog">
          <div class="newPieceInfo">，获得50易加积分</div>
        </div>
      </van-dialog>

      <div class="block"></div>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
import { userUtils } from '@/utils/auth'
import { Dialog } from 'vant'
import activityApi from '@/api/activity'
export default {
  data () {
    return {
      monthList: [7, 8, 9, 10, 11, 12],
      month: 7,
      pieceList: [],
      pieceMonthList: [],
      pieceCount: 0,
      toEndDate: 0,
      monthPieceNum: [0, 0, 0, 0, 0, 0],
      show: false,
      monthPiecePopup: false,
      newPieceDialog: false,
      piece: { count: 4, pieceCode: '202107-1', rangeBegin: 1, rangeEnd: 100 },
      resultCode: '',
      pointDialog: false,
      getPoint: 0,
      scanCount: 0
    }
  },
  created () {
    // 获取一个月的活动剩余天数
    this.month = new Date().getMonth() + 1
    var d = new Date(2021, this.month, 0)
    let date = new Date().getDate()
    this.toEndDate = d.getDate() - date + 1

    this.clientInfo = userUtils.getClientInfo()
    commonUtils.configWxJsSdk().catch(error => {
      this.$emit('error', { errorMsg: error })
    })

    this.init()
  },
  mounted () {
    const u = navigator.userAgent
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    console.log('isIOS', isIOS)
    if (isIOS && location.href.indexOf('#reloaded') === -1) {
      location.href = location.href + '#reloaded'
      location.reload()
    }
  },
  methods: {
    init () {
      activityApi.getAllFregment().then(res => {
        this.resultCode = res.data.resultCode
        if (res.data.resultCode === '0') {
          this.pieceList = res.data.resultData.monthPieceList
          this.pieceCount = res.data.resultData.monthPieceCount
          // this.toEndDate = res.data.resultData.toEndDate + 1
          if (res.data.resultData.isFinish) {
            Dialog.alert({
              message: '已集齐当月碎片，恭喜您获得盲盒礼品一份，奖品将于次月快递！'
            })
          }
          // 计算每月收集进度
          this.pieceMonthList.forEach((month, index) => {
            for (let item of month) {
              if (item.count !== 0) {
                this.monthPieceNum[index] = this.monthPieceNum[index] + 1
              }
            }
          })
        }
      })

      activityApi.pieceClientActivityInfo().then(res => {
        console.log(res.data.resultData)
        if (res.data.resultCode === '0') {
          this.getPoint = res.data.resultData.getPoint
          this.scanCount = res.data.resultData.scanCount
        }
      })
    },
    getMonthImg (item, active) {
      let src = require(`../../../assets/images/activity/fragment/2021-${item}${active ? '-active' : ''}.png`)
      return src
    },
    getImgSrc (index) {
      if (this.month < 7) {
        return
      }

      let data = this.pieceList || []
      if (data && data[index]) {
        let src = require(`../../../assets/images/activity/fragment/home/2021${this.month < 10 ? '0' + this.month : this.month}-${index + 1}${data[index].count === 0 ? 'W' : ''}.png`)
        return src
      }
    },
    getNewPieceImgSrc (pieceCode) {
      let src = require(`../../../assets/images/activity/fragment/home/${pieceCode}.png`)
      return src
    },
    getMonthStyle (index) {
      switch (index) {
        case 0:
          return 'jul'
        case 1:
          return 'aug'
        case 2:
          return 'sep'
        case 3:
          return 'oct'
        case 4:
          return 'nov'
        case 5:
          return 'dec'
      }
    },
    getPieceName (pieceCode) {
      let month = pieceCode.slice(4, 6)
      let monthName = ''
      switch (month) {
        case '07':
          monthName = '7月'
          break
        case '08':
          monthName = '8月'
          break
        case '09':
          monthName = '9月'
          break
        case '10':
          monthName = '10月'
          break
        case '11':
          monthName = '11月'
          break
        case '12':
          monthName = '12月'
          break
      }
      let pieceIndex = pieceCode.slice(7)
      return monthName + '碎片' + pieceIndex
    },

    getNewPiece () {
      this.newPieceDialog = true
    },
    gotoWeb (name) {
      this.$router.push({ name })
    },

    // 活动详情-弹出框
    activityInfoPopup () {
      this.show = true
    },
    // 关闭 活动详情-弹出框
    closePopup () {
      this.show = false
    },
    // 展示当月拼图-弹出层
    showMonthPiece () {
      if (this.resultCode !== '0') {
        return
      }
      this.monthPiecePopup = true
    },
    // 获得最新碎片后，判断是否集齐当月碎片
    collectAllPiece () {
      this.init()
    },

    backHome () {
      window.location.href = 'https://wx.bosch-extra.com.cn/#/tab/home'
    },

    // 扫码
    scanCode () {
      // 测试
      // let code = {
      //   scanCode: '1WZVRCG6BYB77P39DP'
      // }
      // this.lotteryScan(code)
      // if (!this.clientInfo) {
      //   window.location.href = commonUtils.getExtraSite() + '/#/login' + '?redirectUrl'
      // }
      this.$wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['barCode', 'qrCode', 'datamatrix', 'pdf417'], // 可以指定扫二维码还是一维码，默认二者都有
        success: res => {
          let scanData = {
            scanCode: res.resultStr
          }
          this.getLocation(scanData)
        },
        fail: res => {
          this.$toast('调用扫码功能异常')
          console.log('fail', res)
        },
        cancel: function () {
          console.log('scan cancel')
        }
      })
    },

    // 获取经纬度
    getLocation (scanData) {
      this.$wx.getLocation({
        type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: res => {
          scanData.locLat = res.latitude // 纬度，浮点数，范围为90 ~ -90
          scanData.locLong = res.longitude // 经度，浮点数，范围为180 ~ -180。
          this.fragmentScan(scanData)
        },
        fail: function (err) {
          console.log(err)
        }
      })
    },

    // 扫码结果
    fragmentScan (value) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      activityApi.fragmentScan(value).then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          this.piece = res.data.resultData.getPieceList[0]
          this.newPieceDialog = true
        } else {
          this.$notify({
            background: '#1989fa',
            message: res.data.resultMsg,
            className: 'notify-error-msg'
          })
        }
      }).catch(() => {
        this.$toast.clear()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.fragment-page-container{
  position:relative;
  background-image: url('../../../assets/images/activity/fragment/2021bg.png');
  background-repeat: no-repeat;
  height: 812px;
  background-size: 100%;
  background-color: black;
}
.bg-img{
  width: 100vw;
  height: 100%;
}
.bgAnimation{
  animation:bg  6s linear infinite;
}

.back-home{
  width: 45px;
  position: fixed;
  left: 85vw;
  top: 2vh;
  z-index: 10;
}

@keyframes bg{
  from{
    transform: rotate(0);
  }
  to{
    transform: rotate(360deg);
  }
}
.activity-picture{
  width: calc(100% - 10px);
  margin-left: 5px;
  height: 400px;
  position: absolute;
  //background-color: rgba(173, 173, 173, 0.39);
  top: 230px;
  .pic-item{
    width: 32vw;
    height: 32vw;
    //background-color: rgba(250, 235, 215, 0.315);
    position: relative;
    .active-bg{
      position: absolute;
      width: 90%;
    }

    .month-img{
      position: absolute;
      width: 60%;
      left: 20%;
      top: 10%;
      z-index: 1;
    }
  }
  .jul{
    position: absolute;
    top: 5px;
     .month-img-active{
       position: relative;
       top: -2px;
    }
  }
  .aug{
    position: absolute;
    left: 33vw;
    top: -15px;
    //background-color: rgba(240, 248, 255, 0.336);
    .month-img{
      position: relative;
      top: 8px;
      left: 15px;
    }
    .unactived{
      position: relative;
      top: 20px;
    }
  }
  .sep{
    position: absolute;
    left: 66vw;
    top: 20px;
    .month-img-active{
      position: relative;
      top: 8px;
      left: 15px;
    }
    //background-color: rgba(240, 248, 255, 0.336);
  }
  .dec{
    position: absolute;
    top: 230px;
    //background-color: rgba(240, 248, 255, 0.336);
     .month-img{
       position: relative;
     }
    .unactived{
      position: relative;
      top:20px
    }
  }
  .nov{
    position: absolute;
    left: 33vw;
    top: 270px;
    //background-color: rgba(240, 248, 255, 0.336);
    .month-img {
      position: relative;
      left: 12px;
      top: 10px;
    }
    .unactived{
      position: relative;
      top:20px
    }
  }
  .oct{
    position: absolute;
    left: 66vw;
    top: 230px;
    //background-color: rgba(240, 248, 255, 0.336);
    .active-bg{
      position: relative;
      left: 5px;
      top: 10px;
    }
  }
}
.activity-schedule{
  width: 80vw;
  height: 50px;
  position: absolute;
  bottom:110px;
  left: 10vw;
  text-align: center;
  .activity-title{
    color: rgb(253,178,248);
    letter-spacing: 1px;
    font-size: 17px;
    line-height: 35px;
    .activity-rules{
      width: 65px;
      position: relative;
      top: 2px;
    }
  }
  .schedule{
    color: white;
    font-size: 12px;
  }
}
.bottom-nav{
  width: 100%;
  height: 80px;
  position: absolute;
  bottom: 20px;
  display: flex;
  color:white;
  .bottom-nav-btn {
    width: 25vw;
    text-align: center;
    line-height: 60px;
    .bottom-nav-icon{
      width: 60px;
    }
  }
  .bottom-nav-scan-btn{
    width: 50vw;
    height: 100%;
    text-align: center;
    .bottom-nav-icon-scan{
      width: 160px;
      margin-top: 5px;
    }
  }
}
.detail-img{
    width: 300px;
}
.activity-detail{
  position: absolute;
  //top: -500px;
  width: 100%;
  // position: absolute;
  // top: 260px;
  // width: 90vw;
  // z-index: 5;
  // left: 5vw;
  .block{
    width: 100%;
    height: 20px;
  }
    img{
    width:90vw;
    position: relative;
    left: 5vw;
    }
    .close-img{
      width: 65px;
      height: 65px;
      position: relative;
      left: 82vw;
      //right: 5vw;
      top: 45px;
      z-index: 10;
    }
}

.month-piece{
  width: 300px;
  margin-left: calc(50vw - 130px);
  background-color: rgba(255, 255, 255, 0);
  .piece-one{
    width: 80px;
  }
  .piece-two{
    position: relative;
    left: -24px;
    top: -15px;
    width: 120px;
  }
  .piece-three{
    width: 81px;
    position: relative;
    top: -16px;
    left: -50px;

  }
  .piece-four{
    width: 100px;
    position: relative;
    top: -45px;
    height: 85px;
  }
  .piece-five{
    width: 83px;
    position: relative;
    top:-45px;
    left: -25px;
  }
  .piece-six{
   width: 97px;
   position: relative;
   top: -45px;
   left: -49px;
   height: 101px;
  }
}
.van-popup{
    background-color: rgba(0,0,0,0);
}
.newPieceDialog{
  margin-top: 20px;
  text-align: center;
  font-size: 14px;
  color: rgb(59, 59, 59);
  img{
    width: 70px;
  }
  .newPieceInfo{
    margin-bottom: 10px;
  }
}
.bottom-text{
  position: relative;
  top: -35px;
  font-size: 12px;
  left: 1vw;
  color: rgba(255, 255, 255, 0.6);
  transform: scale(0.73);
}
.point{
  font-size: 14px;
  color: white;
  position:relative;
  top:-185px;
  text-align: center;
  width: 100%;
}
.block{
  width: 100%;
  height: 5px;
  background-color: rgb(0, 0, 0);
  position: relative;
  top: -20px;
}
</style>
